import { render, staticRenderFns } from "./DeveloperListCommercialModels.vue?vue&type=template&id=c60fc67c&"
import script from "./DeveloperListCommercialModels.vue?vue&type=script&lang=js&"
export * from "./DeveloperListCommercialModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports